import classNames from "classnames/dedupe";
import { Amble, type AmbleProps } from "./Amble";

export const Preamble = ({ className, ...props }: AmbleProps) => (
  <Amble
    {...props}
    className={classNames("mobius-amble--preamble", className)}
  />
);

Preamble.displayName = "Preamble";
